import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const getAuth = () => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } };
};

let _cachedConfig = null;
let _cacheTime = 0;
const CACHE_TTL = 60000; // 1 minute

/**
 * Get the WhatsApp config for the current company (cached)
 */
export async function getWhatsAppConfig(forceRefresh = false) {
  if (!forceRefresh && _cachedConfig && Date.now() - _cacheTime < CACHE_TTL) {
    return _cachedConfig;
  }
  try {
    const resp = await axios.get(`${BACKEND_URL}/api/whatsapp/config`, getAuth());
    _cachedConfig = resp.data;
    _cacheTime = Date.now();
    return _cachedConfig;
  } catch {
    return { mode: 'wame' };
  }
}

/**
 * Clear cached config (call after saving settings)
 */
export function clearWhatsAppConfigCache() {
  _cachedConfig = null;
  _cacheTime = 0;
}

/**
 * Open a URL via anchor tag click — bypasses COOP blocking
 */
function openLink(url) {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * Send a WhatsApp message — routes based on company config.
 * 3 modes: wame (wa.me link), browser (web.whatsapp.com), api (server-side)
 * @param {string} phone - Phone number (with or without country code)
 * @param {string} message - Message text
 * @returns {Promise<{mode: string, status?: string, error?: string}>}
 */
export async function sendWhatsApp(phone, message) {
  try {
    const resp = await axios.post(
      `${BACKEND_URL}/api/whatsapp/send`,
      { phone, message },
      getAuth()
    );
    const data = resp.data;

    if (data.mode === 'wame' || data.mode === 'browser') {
      // Both link modes — open via anchor tag (bypasses COOP)
      openLink(data.url);
      return { mode: data.mode, status: 'opened' };
    }

    // API mode — message already sent by backend
    return data;
  } catch (error) {
    const detail = error.response?.data?.detail || error.message || 'Failed to send';
    return { mode: 'unknown', status: 'failed', error: detail };
  }
}
